import React from 'react';
import { Lock, UserCheck, Quote, BoxIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SEO } from '../components/SEO';
const principles = [{
  icon: BoxIcon,
  color: 'muted-gold',
  key: 'bounded'
}, {
  icon: Lock,
  color: 'neural-green',
  key: 'sovereignty'
}, {
  icon: UserCheck,
  color: 'ai-teal',
  key: 'human'
}];
export function Philosophy() {
  const {
    t,
    language
  } = useLanguage();
  const seoTitles = {
    en: 'Philosophy - TECHNOLOGY BEYOND CONTROL. | NEW ASIA TECH Core Beliefs',
    id: 'Filosofi - TEKNOLOGI MELAMPAUI KENDALI. | Keyakinan Inti NEW ASIA TECH'
  };
  const seoDescriptions = {
    en: 'NEW ASIA TECH philosophy: Bounded Intelligence, Sovereignty is Non-Negotiable, Human in the Loop. Our core beliefs in designing ethical AI and autonomous systems for the future.',
    id: 'Filosofi NEW ASIA TECH: Kecerdasan Terbatas, Kedaulatan Tidak Dapat Ditawar, Manusia dalam Lingkaran. Keyakinan inti kami dalam merancang AI etis dan sistem otonom untuk masa depan.'
  };
  const seoKeywords = {
    en: 'AI philosophy, bounded intelligence, data sovereignty, human-in-the-loop, ethical AI, responsible technology, AI governance, technology ethics, NEW ASIA TECH philosophy',
    id: 'filosofi AI, kecerdasan terbatas, kedaulatan data, manusia dalam lingkaran, AI etis, teknologi bertanggung jawab, tata kelola AI, etika teknologi, filosofi NEW ASIA TECH'
  };
  return <>
      <SEO title={seoTitles[language]} description={seoDescriptions[language]} keywords={seoKeywords[language]} url="/philosophy" type="article" data-id="element-395" />

      <div className="min-h-screen pt-32 pb-20 px-6" data-id="element-396">
        <div className="max-w-[1200px] mx-auto" data-id="element-397">
          <div className="text-center mb-24 animate-fade-in-up" data-id="element-398">
            <span className="text-xs font-mono text-ai-teal uppercase tracking-widest mb-4 block" data-id="element-399">
              {t('philosophy.subtitle')}
            </span>
            <h1 className="text-5xl md:text-7xl font-display font-bold text-ivory tracking-tighter mb-8" data-id="element-400">
              {t('philosophy.title')}
            </h1>
            <div className="max-w-2xl mx-auto relative" data-id="element-401">
              <Quote className="absolute -top-6 -left-6 text-white/5 w-12 h-12" data-id="element-402" />
              <p className="text-xl text-gray-400 font-light italic" data-id="element-403">
                {t('philosophy.quote')}
              </p>
            </div>
          </div>

          <div className="space-y-32" data-id="element-404">
            {principles.map((principle, idx) => {
            const Icon = principle.icon;
            const isEven = idx % 2 === 0;
            return <section key={idx} className={`grid grid-cols-1 md:grid-cols-2 gap-16 items-center group animate-fade-in-up delay-${(idx + 1) * 100}`} data-id="element-405">
                  <div className={isEven ? 'order-2 md:order-1' : ''} data-id="element-406">
                    <div className="flex items-center mb-6" data-id="element-407">
                      <Icon className={`w-8 h-8 text-${principle.color} mr-4`} data-id="element-408" />
                      <div className="text-9xl font-display font-bold text-white/5 absolute -z-10 translate-x-[-20px]" data-id="element-409">
                        0{idx + 1}
                      </div>
                      <h2 className="text-3xl font-display font-bold text-ivory relative z-10" data-id="element-410">
                        {t(`philosophy.${principle.key}`)}
                      </h2>
                    </div>
                    <p className={`text-gray-400 text-lg leading-relaxed border-l-2 border-white/10 pl-6 group-hover:border-${principle.color} transition-colors duration-500`} data-id="element-411">
                      {t(`philosophy.${principle.key}.desc`)}
                    </p>
                  </div>
                  <div className={`${isEven ? 'order-1 md:order-2' : 'hidden md:block'} h-px bg-gradient-to-r from-transparent via-${principle.color} to-transparent w-full opacity-50 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-412" />
                </section>;
          })}
          </div>
        </div>
      </div>
    </>;
}